module.exports = __webpack_public_path__ + "img/pricing-bg-shape.08c8bebf.png";